import { render, staticRenderFns } from "./programme_questions.vue?vue&type=template&id=567d08da&scoped=true&"
import script from "./programme_questions.vue?vue&type=script&lang=js&"
export * from "./programme_questions.vue?vue&type=script&lang=js&"
import style0 from "./programme_questions.vue?vue&type=style&index=0&id=567d08da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567d08da",
  null
  
)

export default component.exports